/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { LoadingSection } from '@coursera/cds-core';

import _t from 'i18n!nls/embedded-experience';

const styles = {
  // Full-viewport so the host page header, outline, and banners are covered, not just the
  // content area — used while an embedded launch redirects to its target item.
  root: css`
    position: fixed;
    inset: 0;
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--cds-color-neutral-background-primary);
  `,
};

const EmbeddedExperienceLoader = () => (
  <div css={styles.root}>
    <LoadingSection label={_t('Loading...')} />
  </div>
);

export default EmbeddedExperienceLoader;
